import { MarketHome } from 'features/market/marketHome/ui/MarketHome'
import { useUrlStateManager } from 'shared/hooks/useUrlStateManager'
import { useEffect, useState } from 'react'
import { useAppDispatch, useAppSelector } from 'shared/hooks'
import { selectCurrentLocation, selectCurrentSpyId, selectPageState, setPageState, selectCurrentFilter } from 'store/applicationSlice'
import { getStateFromUrl } from 'shared/lib/getStateFromUrl'
import { useReadMonitorByIdQuery } from 'services/monitor'
import { jsonToParams } from 'shared/lib/jsonToParams'
import { paramsToJson } from 'shared/lib/paramsToJson'
import { useUrlStateManagerDefault } from 'shared/hooks/useUrlStateManager'

const PageName = 'market'

export const MarketPage = (): JSX.Element => {
    // const dispatch = useAppDispatch()
    // const state = useAppSelector((state) => selectPageState(state, PageName))
    // const currentSpyId = useAppSelector(selectCurrentSpyId) 
    // const currentLocation =  useAppSelector(selectCurrentLocation) 
    // const currentFilter =  useAppSelector(selectCurrentFilter) 

    // const [defaultUrlState, setDefaultUrlState] = useState<any>({
    //     spyId: undefined,
    //     filters: undefined
    // })
    // const [handledState, setHandledState] = useState<any>()
    // const [spyId, setSpyId] = useState<any>()
    // const [location, setLocation] = useState<any>()
    // const [filter, setFilter] = useState<any>({
    //     bedrooms: [],
    //     beds: [],
    //     pets: []
    // })



//     const handleStateChange = (event: any) => {
//         let newState: any = {}
//         event.forEach((property: any) => {
//             newState[property.name] = {
//                 timeStamp: Date.now(),
//                 value: property.value 
//             }
//         })

//         dispatch(setPageState({
//             name: PageName,
//             state: {
//                 ...state,
//                 ...newState
//             }
//         }))
//     }

//     useEffect(() => {
//         const newState = getStateFromUrl(urlState)

//         dispatch(setPageState({
//             name: PageName,
//             state: {
//                 ...state,
//                 ...newState
//             }
//         }))
//     }, [])

//     useEffect(() => {
//         const handleUrl = () => {
//             if (currentSpyId === undefined){
//                 setUrtState(state || {})
//                 return
//             }

//             const newState = {
//                 ...state,
//                 spyId: currentSpyId,
//                 filter: currentFilter
//             }
//             setUrtState(newState || {})      
//         }

//         const handleState = () => {
//             setSpyId(currentSpyId)
//             setLocation(currentLocation)

//             if (currentFilter !== undefined){
//                 setFilter({
//                     bedrooms: [],
//                     beds: [],
//                     pets: [],
//                     ...currentFilter.value
//                     }
//                 )
//             } 
//         }

//         handleUrl()
//         handleState()
//     }, [
//         currentSpyId,
//         currentLocation, 
//         currentFilter
//     ])

//     const [readMonitorByIdQueryParams, setReadMonitorByIdQueryParams] = useState<any>(undefined);
//     const [readMonitorByIdOptions, setReadMonitorByIdOptions] = useState<any>(
//         {
//             skip: true
//         }
//     )

//     const {
//         data: readMonitorByIdQueryData,
//         isLoading: readMonitorByIdQueryIsLoading
//     } = useReadMonitorByIdQuery(readMonitorByIdQueryParams, readMonitorByIdOptions);

//     useEffect(() => {
//         setReadMonitorByIdQueryParams({
//             ...readMonitorByIdQueryParams,
//             monitorId: currentSpyId?.value
//         });

//         setReadMonitorByIdOptions(
//             {
//                 ...readMonitorByIdOptions,
//                 skip: currentSpyId === undefined,
//             }
//         )
//     }, [
//         currentSpyId
//     ])

//     useEffect(() => {
//         const handle = async () => {
//             if (readMonitorByIdQueryData === undefined){
//                 return
//             }

//             if (currentLocation === undefined){
//                 handleStateChange([
//                     {                                
//                         name: 'location',
//                         value: readMonitorByIdQueryData?.locations[0]
//                     }
//                 ])
//             }
//         }

//         handle()
//     }, [
//         readMonitorByIdQueryData
//    ])

    return (
        <MarketHome />  
    )
}